// extracted by mini-css-extract-plugin
export default {"button":"OpenPctButton_button__Xzjz9"};